import { Box, } from "@mui/material";
import { useState } from "react";
import GridLayout, { WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import WidgetCard from "../../components/dashboard/WidgetCard";
import SearchBarGlobalDashboard from "../../components/searchbar/SearchBarGlobalDashboard";
import useWidgets from "../../hooks/globalDashboard/useWidgets";
import useWorkRoute from "../landing/useWorkRoute";


const ResponsiveGrid = WidthProvider(GridLayout);
const GRID_COLS = 6;
const GRID_ROW_HEIGHT = 100;

export const colors = {
  blue: "#1a77d2",
  purple: "#5249ca",
  lightBlue: "#5d94f9",
  lightPurple: "#867ef8",
  blueGreen: "#5cc4c5",
  green: "#2a9988",
  lightGreen: "#81c1b9",
  lightBlueGreen: "#cdf3ef",
  gray: "#bed8d5",
  lightGray: "#ebf7f5",
};


const GlobalDashboardPage = () => {
  const [isEditableView, setIsEditableView] = useState<boolean>(false);

  const {
    start,
    setStart,
    end,
    setEnd,
    propertyGroupId,
    setPropertyGroupId,
    propertyGroups,
  } = useWorkRoute();

  const { widgets } = useWidgets({
    propertyGroupId,
    start,
    end: end || new Date()
  });

  return (
    <>
      <SearchBarGlobalDashboard
        propertyGroups={propertyGroups}
        setPropertyGroupId={setPropertyGroupId}
        propertyGroupId={propertyGroupId}
        start={start}
        setStart={setStart}
        end={end}
        setEnd={setEnd}
      />

      <Box sx={{ mt: 3 }}>
        <ResponsiveGrid
          className="layout"
          layout={widgets.map((widget) => widget.layout)}
          cols={GRID_COLS}
          rowHeight={GRID_ROW_HEIGHT}
          draggableHandle=".drag-handle"
          isDraggable={isEditableView}
          isResizable={isEditableView}
          margin={[20, 20]}
          containerPadding={[0, 0]}
        >
          {widgets.map((widget) => (
            <Box key={widget.layout.i} data-grid={widget.layout} className="drag-handle" style={{ cursor: isEditableView ? "grab" : "default" }}>
              <WidgetCard title={widget.title} downloadButtons={widget.downloadButtons}>{widget.component}</WidgetCard>
            </Box>
          ))}
        </ResponsiveGrid>
      </Box>
    </>
  );
};

export default GlobalDashboardPage;
